import { SVGProps } from 'react';

const SvgClockSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M8 1.833a6.167 6.167 0 1 0 0 12.334A6.167 6.167 0 0 0 8 1.833ZM.833 8a7.167 7.167 0 1 1 14.334 0A7.167 7.167 0 0 1 .833 8Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M8 3.5a.5.5 0 0 1 .5.5v3.691l2.39 1.195a.5.5 0 1 1-.447.895L7.776 8.447A.5.5 0 0 1 7.5 8V4a.5.5 0 0 1 .5-.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgClockSmall;
